export type SitePlanFilterDataTypes = {
  key: string;
  value: string | number;
  type?: string;
  isActive?: boolean;
};

export interface SitePlanFilterSelectionTypes {
  data: SitePlanFilterDataTypes[];
  maxHeight?: string;
  searchPlaceHolder?: string;
  onSelectItemChange?: ({ key }) => void;
  onSearchItem?: (val: string) => void;
}

export interface SitePlanFilterTypes {
  projectItem?: number[];
  direction?: string[];
  floor?: SitePlanFilterDataTypes[];
  itemCode?: SitePlanFilterDataTypes[];
  square?: number[];
  floorNumber?: number[];
  bedroom?: number[];
}

export const DEFAULT_SITE_PLAN_FILTER: SitePlanFilterTypes = {
  itemCode: [],
  square: [],
  projectItem: [],
  direction: [],
  bedroom: [],
  floor: [],
  floorNumber: [],
};
